import React, { useState } from 'react';
import { Button } from '@bedrock/components';
import { useCountDown } from 'ahooks';

const LoadingBtn = () => {
    const [targetDate] = useState<number>(Date.now() + 20000);
    const [countdown] = useCountDown({
      targetDate,
    });
    
    return (
        <Button loading type='text'>
             发票上传识别中，请稍后...{Math.round(countdown / 1000)}s
        </Button>
    )
}

export default LoadingBtn;
